import { Column } from '@/fsd/entities/table/model/types/Column';

export const MUTUAL_SETTLEMENTS_LIST_DEFAULT_COLUMNS: Column[] = [
  { id: 'id', label: 'ID', isVisible: true },
  { id: 'date', label: 'Дата', isVisible: true },
  { id: 'organisation', label: 'Организация', isVisible: true },
  { id: 'counterparty', label: 'Контрагент', isVisible: true },
  { id: 'start_period', label: 'На начало периода', isVisible: true },
  { id: 'paid', label: 'Оплачено', isVisible: true },
  { id: 'accepted', label: 'Принято', isVisible: true },
  { id: 'end_period', label: 'На конец периода', isVisible: true },
  { id: 'status', label: 'Статус', isVisible: true },
];
